import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

import {
    GallerySection,
    GalleryTitle,
    GridContainer,
    CategoryCard,
    CategoryImg,
    CategoryOverlay,
    CategoryLabel,
    ModalImageGrid,
    ModalImage
} from './GalleryElements';

const categoriesData = [
    {
        id: 1,
        title: "Custom Furniture",
        thumbnail: "/Custom furniture/1227fdc2-89bc-4b46-b6d5-04f7324bf2ad.png",
        images: [
            "/Custom furniture/1227fdc2-89bc-4b46-b6d5-04f7324bf2ad.png",
            "/Custom furniture/3ca5656f-23ec-48b4-b15a-7b621cb0c514.png",
            "/Custom furniture/51eebd08-1ca1-4d57-bbd4-491d227207e6.png",
            "/Custom furniture/548fc805-d238-4b1f-8d77-76c3c8a585d0.png",
            "/Custom furniture/78250e04-15bd-4b6e-97c7-07583ff93b13.png",
            "/Custom furniture/c86f3ea3-dd6f-4047-8f6b-69846a8e426d.png",
            "/Custom furniture/d7d00292-7107-442e-803e-fcd691d5f42c.png",
            "/Custom furniture/d93122bc-e586-4089-b9e0-68bfd6f74922.png",
            "/Custom furniture/f80a08be-8b72-4409-aa37-c9c1841407f0.png",
            "/Custom furniture/pöytä.png",
            "/Custom furniture/pyötä.png"
        ]
    },
    {
        id: 2,
        title: "Decks and Pergola",
        thumbnail: "/Decks and pergola/18284dc6-1f7a-4b5f-b3ff-1b611a6ee135.png",
        images: [
            "/Decks and pergola/18284dc6-1f7a-4b5f-b3ff-1b611a6ee135.png",
            "/Decks and pergola/1c0dbe10-cebe-46f7-9e74-145ef377505e.png",
            "/Decks and pergola/5afe6883-eb8c-47bf-b874-40e4645743be.png",
            "/Decks and pergola/64b2b7dd-8485-472f-af3b-7fdfd172d15c.png",
            "/Decks and pergola/d666323a-d447-49f8-a9cb-a63a50627f7f.png",
            "/Decks and pergola/f87942e2-c251-43ed-a694-8de5639f54c6.png",
            "/Decks and pergola/ff6f7f47-022a-4ef5-8a7f-5ad90e79ddfd.png"
        ]
    },
    {
        id: 3,
        title: "Flooring",
        thumbnail: "/Flooring/22591f63-5f1c-4fca-8184-a179f5faccaa.png",
        images: [
            "/Flooring/22591f63-5f1c-4fca-8184-a179f5faccaa.png",
            "/Flooring/41607e8f-4e52-4d94-a95d-d61b2838709a.png",
            "/Flooring/4479b196-b8e0-4460-b91b-05f2edc136fe.png",
            "/Flooring/466a5bf9-1580-4ff9-9db0-188d9480056c.png",
            "/Flooring/4c41383e-e8d6-4d34-be6b-f462d91e1c84.png",
            "/Flooring/65961b6d-97b3-42d2-9c83-333ba31ab18b.png",
            "/Flooring/774b88fd-6387-431d-bb96-d6a57a35a0d3.png",
            "/Flooring/782198b6-4111-4900-a46e-30847f9b2678.png",
            "/Flooring/865b26de-1e1e-4013-a24e-2680f22101ca.png",
            "/Flooring/c3bd00e9-6395-4c6b-a582-8ed2e45e0bf4.png",
            "/Flooring/d147d886-3abc-4c82-b7be-e516cf305580.png",
            "/Flooring/e5695022-3ab9-4137-a852-bece30902283.png",
            "/Flooring/f888d229-1efb-4577-9973-b4c36b847dbb.png",
            "/Flooring/fbf46a34-946e-4ca4-8db9-e873896ef7dd.png"
        ]
    },
    {
        id: 4,
        title: "Kitchen Renovation",
        thumbnail: "/Kitchen renovation/66ec3432-cf9d-413a-bdc1-c1d773d638f7.png",
        images: [
            "/Kitchen renovation/66ec3432-cf9d-413a-bdc1-c1d773d638f7.png"
        ]
    },
    {
        id: 5,
        title: "Painting & Wallpaper",
        thumbnail: "/Painting wallpaper/0092e853-280e-41c1-9ecf-94358151469a.png",
        images: [
            "/Painting wallpaper/0092e853-280e-41c1-9ecf-94358151469a.png",
            "/Painting wallpaper/5e6d11d7-5410-4967-9d6e-948743604583.png",
            "/Painting wallpaper/Autotalli maalaus.png"
        ]
    },
    {
        id: 6,
        title: "Restaurant Renovation",
        thumbnail: "/Restaurant renovation/0db4e47d-6dc6-40f1-a462-f4be22281928.png",
        images: [
            "/Restaurant renovation/0db4e47d-6dc6-40f1-a462-f4be22281928.png",
            "/Restaurant renovation/58c33bbc-05f3-4873-936e-45324d458aeb.png",
            "/Restaurant renovation/83786dd1-dddb-4dcc-9544-3089fc9ad241.png",
            "/Restaurant renovation/a785ac9b-601e-4a4d-be7c-671be7091a4a.png",
            "/Restaurant renovation/bc5adc0c-9d25-4a98-bc78-09e6730fa98e.png",
            "/Restaurant renovation/ravintola kassa.png",
            "/Restaurant renovation/ravintola kassa1.png"
        ]
    },
    {
        id: 7,
        title: "Sofa Manufacture & Repair",
        thumbnail: "/Sofa manufacturere_repair/241f54db-79e7-478d-8c01-1601eda28dd0.png",
        images: [
            "/Sofa manufacturere_repair/241f54db-79e7-478d-8c01-1601eda28dd0.png",
            "/Sofa manufacturere_repair/41ab5276-627b-46da-aec6-e568e6e07ddb.png",
            "/Sofa manufacturere_repair/Ravintola sohva ja pöytä.png",
            "/Sofa manufacturere_repair/fc93341d-4a1d-4b0a-a497-9cfbfcbba8ce.png"
        ]
    }
];

const Gallery = () => {
    const [showModal, setShowModal] = useState(false);
    const [activeCategory, setActiveCategory] = useState(null);

    const handleOpen = (category) => {
        setActiveCategory(category);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setActiveCategory(null);
    };

    return (
        <GallerySection id="Gallery">
            <GalleryTitle>Our Work</GalleryTitle>

            <GridContainer>
                {categoriesData.map((category) => (
                    <CategoryCard key={category.id} onClick={() => handleOpen(category)}>
                        <CategoryImg src={category.thumbnail} alt={category.title} loading="lazy" />
                        <CategoryOverlay>
                            <CategoryLabel>{category.title}</CategoryLabel>
                        </CategoryOverlay>
                    </CategoryCard>
                ))}
            </GridContainer>

            {activeCategory && (
                <Modal show={showModal} onHide={handleClose} size="lg" centered scrollable>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontWeight: 600 }}>{activeCategory.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: '#f9f9f9' }}>
                        <p style={{ color: '#555', marginBottom: '1.5rem', fontSize: '1.4rem' }}>
                            Showcasing our recent {activeCategory.title.toLowerCase()} projects. Click an image to view in full screen and zoom.
                        </p>
                        <PhotoProvider photoClosable={true}>
                            <ModalImageGrid>
                                {activeCategory.images.map((imgUrl, index) => (
                                    <PhotoView key={index} src={imgUrl}>
                                        <ModalImage
                                            src={imgUrl}
                                            alt={`${activeCategory.title} img-${index}`}
                                            style={{ cursor: 'zoom-in' }}
                                            loading="lazy"
                                        />
                                    </PhotoView>
                                ))}
                            </ModalImageGrid>
                        </PhotoProvider>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose} style={{ fontSize: '1.4rem', padding: '0.8rem 1.5rem' }}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </GallerySection>
    )
}

export default Gallery;

